export const version = "2.1.3"
export const reCapKey = "6Ld_Cu0gAAAAAIhC4cGfa3ZZ91surXuBtkBR16zg";
export const API_URL = "https://pos-server.wellclean.com.my/staging/";
export const CHECK_BILL_URL = `${API_URL}checkBillStatus`;
